"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoralisData = void 0;
/**
 * The MoralisData class represents the value of a native currency (like ETH, SOL, BNB etc.)
 *
 * @internal
 * @category DataType
 */
var MoralisData = /** @class */ (function () {
    function MoralisData() {
    }
    return MoralisData;
}());
exports.MoralisData = MoralisData;
//# sourceMappingURL=MoralisData.js.map